import { isValidEmail } from "@/lib/emailCapture";

export type WholesaleInquiryInput = {
  businessName?: string;
  contactName?: string;
  email?: string;
  message?: string;
};

export type WholesaleInquiryErrors = {
  businessName?: string;
  contactName?: string;
  email?: string;
};

export type WholesaleValidation = {
  valid: boolean;
  errors: WholesaleInquiryErrors;
};

/**
 * Validate a "become a wholesaler" inquiry. Business name, contact name and a
 * well-formed email are required; the message is optional.
 */
export function validateWholesaleInquiry(input: WholesaleInquiryInput): WholesaleValidation {
  const errors: WholesaleInquiryErrors = {};

  if (!input.businessName || !input.businessName.trim()) {
    errors.businessName = "Business name is required.";
  }
  if (!input.contactName || !input.contactName.trim()) {
    errors.contactName = "Your name is required.";
  }
  if (!input.email || !isValidEmail(input.email)) {
    errors.email = "A valid email address is required.";
  }

  return { valid: Object.keys(errors).length === 0, errors };
}
